import { Components } from '@mui/material';

export default {
  styleOverrides: { root: { backgroundColor: 'transparent' } },
} as Components;
